/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const HatGlasses = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.4782 5.12187C8.12366 5.00426 7.73662 5.16547 7.5704 5.49998L5.33438 9.99997L18 9.99996L22 9.99995L22 11.4999L18 11.5L2 11.5V9.99997H3.65941L6.22709 4.8325C6.72575 3.82896 7.88687 3.34533 8.95048 3.69816L11.7443 4.62494C11.9036 4.6778 12.0761 4.67567 12.2341 4.61889L14.6964 3.73397C15.7499 3.3554 16.9214 3.80879 17.4455 4.7979L19.6627 8.98214L18.3373 9.68447L16.1201 5.50023C15.9454 5.17052 15.5549 5.01939 15.2037 5.14559L12.7414 6.03051C12.2674 6.20084 11.75 6.20722 11.272 6.04865L8.4782 5.12187ZM9.89994 16.6C9.89994 17.7598 8.95974 18.7 7.79994 18.7C6.64015 18.7 5.69995 17.7598 5.69995 16.6C5.69995 15.4402 6.64015 14.5 7.79994 14.5C8.95974 14.5 9.89994 15.4402 9.89994 16.6ZM11.3999 16.6001C11.3999 18.5882 9.78813 20.2 7.79994 20.2C5.81176 20.2 4.20001 18.5882 4.19995 16.6001H3L3 15.1001H4.52633C5.09511 13.8607 6.34701 13 7.79994 13C9.25288 13 10.5048 13.8607 11.0736 15.1001H12.9264C13.4951 13.8607 14.747 13 16.2 13C17.6529 13 18.9048 13.8607 19.4736 15.1001H21.0001V16.6001H19.8C19.7999 18.5882 18.1882 20.2 16.2 20.2C14.2118 20.2 12.6 18.5882 12.6 16.6001H11.3999ZM16.2 18.7C17.3598 18.7 18.3 17.7598 18.3 16.6C18.3 15.4402 17.3598 14.5 16.2 14.5C15.0402 14.5 14.1 15.4402 14.1 16.6C14.1 17.7598 15.0402 18.7 16.2 18.7Z"
                        fill={color}
                    />
                </svg>
        );
    };
